import { render } from "./ActivityTag.vue?vue&type=template&id=684ddefe&scoped=true"
import script from "./ActivityTag.vue?vue&type=script&lang=js"
export * from "./ActivityTag.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684ddefe"]])

export default __exports__